import script from "./ElementOpacity.vue?vue&type=script&lang=ts&setup=true"
export * from "./ElementOpacity.vue?vue&type=script&lang=ts&setup=true"

import "./ElementOpacity.vue?vue&type=style&index=0&id=54aad0f0&lang=scss&scoped=true"

import exportComponent from "C:\\work\\to-create\\bailing\\yc-bailing-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54aad0f0"]])

export default __exports__